module.exports = __webpack_public_path__ + "img/face-sad-tear.9615c121.svg";